import { Modal } from '@veneer/core';
import styled from 'styled-components';

import {
  color,
  layout,
  typography,
  bigDesktop,
  mobile,
  smallDesktop,
  tablet,
} from '../../GlobalStyles';

export const ModalContainer = styled(Modal)`
  && {
    border-radius: ${layout.cornerRadius4}px;
    width: 824px;
    height: 700px;
    padding: 52px 22px 18px 40px;

    ${tablet} {
      max-width: 622px;
      width: 622px;
      padding: 52px 0px 52px 27px;
    }

    ${mobile} {
      width: 382px;
      max-width: 382px;
      padding: 50px 13px 0px ${layout.size5}px;
    }

    [class~='vn-modal__close'] {
      color: ${color.gray12};
    }
  }
`;

export const ContainerWrapper = styled.div`
  max-width: 749px;
  max-height: 596px;
  padding: 0 12px 0 0;
  overflow: overlay;

  ${tablet} {
    max-width: 532px;
    padding: 0 12px 0 13px;
  }

  ${mobile} {
    max-width: 382px;
    padding: 0px 10px 0px 0px;
  }

  &::-webkit-scrollbar {
    width: ${layout.size1}px;

    &-thumb {
      border-radius: 2px;
      background: ${color.gray6};
    }

    &-track {
      display: none;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  box-sizing: border-box;
`;

export const Title = styled.div.attrs((props) => ({
  className: `${props.theme.mb ? 'subtitle-large' : 'title-small'}`,
}))`
  top: 0;
  color: ${color.gray12};
  padding-bottom: 22px;
  text-align: left;
  background-color: ${color.white};
`;

export const ContainerRows = styled.div`
  display: flex;
  flex-direction: row;
  gap: 36px;
  width: 100%;
  align-items: flex-start;

  ${smallDesktop} {
    gap: 36px;
  }

  ${mobile} {
    gap: 20px;
  }
`;

export const ContainerColumn = styled.div`
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 156px;
  gap: 14px;

  ${bigDesktop} {
    width: 180px;
  }

  ${smallDesktop} {
    width: 180px;
  }

  @media only screen and (max-width: 375px) {
    // mobile
    width: 125px;
  }
`;

export const Header = styled.div`
  top: 0px;
  position: sticky;
  display: flex;
  flex-direction: column;
  background-color: ${color.white};
  align-items: center;
  border-bottom: 1px solid ${color.gray12};
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${layout.size8}px;
  width: 100%;
  max-width: 224px;

  input[id^='select-printer'] {
    padding-top: 6px;
    padding-bottom: 6px;
    border: solid ${color.gray7} 1px;

    font-size: ${typography.size1};
    line-height: ${typography.lineHeight2};

    ${mobile} {
      font-size: ${typography.size0};
      line-height: ${typography.lineHeight1};
    }
  }
  svg[class^='vn-icon'] {
    fill: ${color.gray7};
  }
  ${tablet} {
    max-width: 253px;
  }
  ${mobile} {
    width: 156px;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 110px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Image = styled.img`
  max-width: 110px;
  padding-bottom: ${layout.size6}px;
`;

export const Spec = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
`;

export const FeatureUnitSpecs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const FeatureNameSpecs = styled.a`
  display: flex;
  justify-content: center;
  color: ${color.royalBlue7};
  word-wrap: break-word;
  line-height: ${typography.lineHeight2};
  gap: ${layout.size1}px;

  &:hover {
    color: ${color.royalBlue7};
  }

  &:visited {
    color: ${color.royalBlue7};
  }
`;

export const FeatureNameTextWrapper = styled.div`
  margin-top: 2px;
`;

export const FeatureNameText = styled.span`
  color: ${color.royalBlue7};

  &:hover {
    color: ${color.royalBlue7};
  }

  &:visited {
    color: ${color.royalBlue7};
  }
`;

export const FeatureDescription = styled.div`
  color: ${color.gray7};
  word-wrap: break-word;
`;

export const Feature = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
`;

export const FeatureUnit = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${layout.size3}px;
  padding: 30px 0 ${layout.size4}px 0;
  border-top: 1px solid ${color.gray12};
`;

export const FeatureInfoWrapper = styled.div`
  margin: ${layout.size1}px 0;
`;

export const FeatureName = styled.div`
  color: ${color.gray12};
  word-wrap: break-word;
`;

export const CircleIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const FeatureNumber = styled.div`
  color: ${color.gray12};
  display: flex;
  justify-content: center;
`;
